document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".button").forEach((button) => {
    let circle = button.querySelector(".button_circle");

    if (!circle) {
      circle = document.createElement("span");
      circle.classList.add("button_circle");
      button.appendChild(circle);
    }

    button.addEventListener("mouseenter", function (e) {
      const rect = button.getBoundingClientRect();
      circle.style.left = e.clientX - rect.left + "px";
      circle.style.top = e.clientY - rect.top + "px";
    });

    button.addEventListener("mouseleave", function (e) {
      const rect = button.getBoundingClientRect();
      circle.style.left = e.clientX - rect.left + "px";
      circle.style.top = e.clientY - rect.top + "px";
    });
  });
});
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.js-scroll-to-section');

    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        const targetSelector = this.dataset.target;
        const target = document.querySelector(targetSelector);
        if (!target) return;

        const stickyHeader =
          document.querySelector('sticky-header') ||
          document.querySelector('.header-wrapper') ||
          document.querySelector('.shopify-section-header-sticky') ||
          document.querySelector('#shopify-section-header');

        let headerHeight = 0;
        if (stickyHeader) {
          headerHeight = stickyHeader.offsetHeight;
        }

        const extraOffset = 30;
        const targetTop = target.offsetTop - headerHeight - extraOffset;

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });
      });
    });
  });





